import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-confirmation',
  templateUrl: './delete-confirmation.component.html'
})
export class DeleteConfirmationComponent implements OnInit {
  @Input() modalText: string;
  @Input() modContent: string;
  @Input() modSubContent: string;
  @Input() btnPrimary: { text: string, isPrimary: true };
  @Input() btnSecondary: { text: string, isPrimary: true };
  @Input() btnTertiary: { text: string, isPrimary: true };
  @Input() isWarning?= true;
  @Input() showClose?= true;
  @Input() btnTertiaryDisabled = false;
  @Input() btnSecondaryDisabled = false;
  @Input() btnPrimaryDisabled = false;

  @Output('btnPrimaryClickEmitter') btnPrimaryClickEmitter = new EventEmitter<any>();
  @Output('btnSecondaryClickEmitter') btnSecondaryClickEmitter = new EventEmitter<any>();
  @Output('btnTertiaryClickEmitter') btnTertiaryClickEmitter = new EventEmitter<any>();

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  public btnPrimaryClick() {
      this.btnPrimaryClickEmitter.emit({});
      this.activeModal.close();
  }

  public btnSecondaryClick() {
    this.btnSecondaryClickEmitter.emit({});
    this.activeModal.close();
  }
  public btnTertiaryClick() {
    this.btnTertiaryClickEmitter.emit({});
    this.activeModal.close();
  }
  closeModal() {
    this.activeModal.close();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/components/delete-confirmation/delete-confirmation.component.ts